// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bI37R","inner":"Footer_inner__1KPDh","nextIcon":"Footer_nextIcon__T1RNc","innerLeft":"Footer_innerLeft__1nddd"};